const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://dash.softup.agency';

/**
 * First-party page view beacon.
 *
 * Sends no cookie and no identifier — the server derives a daily-salted hash
 * for unique counting. Failures are swallowed: analytics must never affect
 * what a visitor sees.
 */
function send(payload) {
  const url = `${BACKEND_URL}/api/pageview`;
  const body = JSON.stringify(payload);
  try {
    // sendBeacon survives the page being closed mid-navigation, which is
    // exactly what happens when someone taps through to WhatsApp.
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch (err) {
    /* never surface analytics failures */
  }
}

function context() {
  const params = new URLSearchParams(window.location.search);
  return {
    lang: document.documentElement.lang || undefined,
    referrer: document.referrer || undefined,
    utm_source: params.get('utm_source') || undefined,
    utm_medium: params.get('utm_medium') || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
  };
}

function suppressed() {
  if (typeof window === 'undefined') return true;
  if (navigator.doNotTrack === '1' || window.doNotTrack === '1') return true;
  // react-snap drives a real browser at build time.
  if (navigator.webdriver) return true;
  return false;
}

/**
 * An interaction worth counting as a conversion — a WhatsApp click, say, which
 * takes the visitor off the site and would otherwise never be attributed.
 */
export function trackEvent(eventType, path) {
  if (suppressed()) return;
  send({
    ...context(),
    path: path || window.location.pathname,
    event_type: eventType,
  });
}

export function trackPageview(path) {
  if (suppressed()) return;
  send({ ...context(), path: path || window.location.pathname });
}
